import { FormEvent, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (user) {
    return <Navigate to={defaultRouteForRole(user.role)} replace />;
  }

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const tokens = await login(email.trim().toLowerCase(), password);
      const target =
        tokens.must_reset_pw
          ? '/setup-password'
          : (location.state as { from?: string } | null)?.from ?? '/dashboard';
      navigate(target, { replace: true });
    } catch (err) {
      setError(messageFor(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="auth-page">
      <div className="auth-card" role="form" aria-label="Anmeldung">
        <img
          src="/tfc-logo-original.png"
          alt="THE FOODVENIENCE COMPANY · ROBOTICS · FOOD VENDING"
          className="auth-brand-img"
        />
        <h1 className="auth-title">LEADCRAFT</h1>
        <p className="auth-claim">LEAD-ERFASSUNG · UNITI 2026</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <label className="auth-field">
            <span className="auth-field__label">E-MAIL</span>
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="auth-input"
              autoFocus
            />
          </label>

          <label className="auth-field">
            <span className="auth-field__label">PASSWORT</span>
            <input
              type="password"
              autoComplete="current-password"
              required
              minLength={1}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="auth-input"
            />
          </label>

          {error ? (
            <div className="auth-error" role="alert">
              {error}
            </div>
          ) : null}

          <button type="submit" disabled={busy} className="auth-submit">
            {busy ? 'WIRD GEPRÜFT…' : 'ANMELDEN'}
          </button>
        </form>
        <p className="auth-footer" style={{ marginTop: 16 }}>
          <a href="/reset-password" style={{ color: 'inherit' }}>Passwort vergessen?</a>
        </p>
        <p className="auth-footer">© 2026 THE FOODVENIENCE COMPANY GmbH · ROBOTICS · FOOD VENDING</p>
      </div>
    </main>
  );
}

export function defaultRouteForRole(role: string): string {
  switch (role) {
    case 'super_admin':
      return '/admin/tenants';
    case 'operator_admin':
      return '/dashboard';
    case 'dispatcher':
      return '/leads';
    case 'employee':
      return '/capture';
    default:
      return '/dashboard';
  }
}

function messageFor(err: unknown): string {
  const detail = (err as { detail?: string })?.detail;
  if (detail === 'invalid_credentials') return 'E-Mail oder Passwort falsch.';
  if (detail === 'user_not_found_or_inactive') return 'Konto ist deaktiviert.';
  return 'Anmeldung fehlgeschlagen. Bitte erneut versuchen.';
}
